import { Field } from "@eisox/design-system";

import { useFieldErrors } from "../field.hook";

interface FieldErrorsProps {
  className?: string;
}

const FieldErrors = ({ className }: FieldErrorsProps) => (
  <Field.Errors className={className} errors={useFieldErrors()} />
);

export { FieldErrors };
export type { FieldErrorsProps };
